// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PickupInstructionsModal .Textarea {
  color: var(--bs-primary);
}
.PickupInstructionsModal .Textarea.form-control:not(.is-valid):not(.is-invalid):not(.is-dirty) {
  border-color: var(--bs-primary);
}`, "",{"version":3,"sources":["webpack://./src/features/Locations/components/PickupInstructionsModal/styles.scss"],"names":[],"mappings":"AACE;EACE,wBAAA;AAAJ;AACI;EACE,+BAAA;AACN","sourcesContent":[".PickupInstructionsModal {\n  .Textarea {\n    color: var(--bs-primary);\n    &.form-control:not(.is-valid):not(.is-invalid):not(.is-dirty) {\n      border-color: var(--bs-primary);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
